export default __webpack_public_path__ + "static/media/hanzo-intro.6c136b77.mp3";